/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import React, { useEffect, useRef, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
    func, string, shape, bool,
} from 'prop-types';
import {
    Button, DialogTitle, ExpansionPanel, ExpansionPanelDetails, ExpansionPanelSummary, SvgIcon, Typography,
} from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import CloseIcon from '@material-ui/icons/Close';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { useSelector, useDispatch } from 'react-redux';
import index from '@module-logger/mbp';
import {
    getIsProductFilterZipcodeValid,
    getUserState,
    getWineData,
} from '../../../../../../../state/ducks/App/App-Selectors';
import AgeVerificationRecipientForm from '../partials/AgeVerificaitonRecipientForm';
import GraphqlWineCompliance from '../../GraphqlAddon/Partials/GraphqlWineCompliance';
import { getBrand } from '../../../../../../pages/Account/state/ducks/Common/Common-Selectors';
import GraphqlWineRestrictions from '../partials/GraphqlWineRestrictions';
import { resetWineData } from '../../../../../../../state/ducks/App/App-Actions';

const useStyles = makeStyles((theme) => ({
    contDrawer: {
        overflowX: 'hidden',
        height: '578px',
        width: '397px',
        borderRadius: '0 10px 10px 0',
        padding: '3px 5px 0px 17px',
        backgroundColor: 'rgba(242, 242, 242, 1)',
        position: 'absolute',
    },
    drawer: {
        backgroundColor: theme.palette.white,
        zIndex: '200',
    },
    dialogContent: {
        padding: '0px 24px',
        '@media screen and (max-width: 600px)': {
            paddingTop: '8px 21px',
        },
        '&:first-child': {
            padding: '0px',
        },
    },
    buttonContainer: {
        display: 'flex',
        margin: '24px 0px',
        textTransform: 'capitalize',
        '& .MuiButton-root.Mui-disabled': {
            backgroundColor: theme.palette.cms?.grey || '#b9b8b8',
            color: theme.palette.cms?.white || '#ffffff',
            border: 'inherit',
        },
    },
    addonsVerificationMobile: {
        position: 'relative',
        margin: '10px',
        '& > div': {
            padding: '10px',
        },
        '& h3': {
            fontSize: '1.125rem',
        },
        '& .age-verification::before': {
            top: '0px',
        },
        '& .age-verification::after': {
            top: '-25px',
        },
        '& .zip-code-error::after': {
            top: '0px',
        },
    },
    addonsVerification: {
        position: 'relative',
        maxWidth: '500px',
        borderRadius: '16px',
        '& .zip-code-success': {
            '&::before': {
                content: 'inherit',
            },
            '&::after': {
                top: '28px',
                left: '15px',
            },
        },
    },
    dialogHeader: {
        padding: '16px 24px',
        '& h2': {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
        },
    },
    header: {
        fontSize: '1rem',
        lineHeight: '1.5rem',
        textDecoration: 'underline',
        marginRight: '12px',
        fontWeight: 400,
    },
    mobileModal: {
        padding: '25px 0px 16px',
        '@media screen and (max-width: 600px)': {
            paddingTop: '20px',
        },
        '& .input-field': {
            minHeight: '45px',
            marginLeft: '12px',
        },
        '& .age-verification.success::after': {
            content: 'inherit',
        },
        '& .age-verification.success::before': {
            content: 'inherit',
        },
        '& .age-verification.error::after': {
            content: 'inherit',
            '@media screen and (max-width: 600px)': {
                top: '5px',
            },

        },
        '& .age-verification.error::before': {
            content: '"Must be over 21"',
            color: theme.palette.cms?.errorMessage || '#DF3030',
            lineHeight: '19px',
            fontSize: '12px',
            marginTop: '4px',
            '@media screen and (max-width: 600px)': {
                fontSize: '0.75rem',
            },
        },
        '& .age-verification.error.error-invalid-date::before': {
            content: '"Please enter a valid date."',
            color: theme.palette.cms?.errorMessage || '#DF3030',
            paddingLeft: '0px',
            fontSize: '14px',
            position: 'absolute',
            top: 0,
            '@media screen and (max-width: 600px)': {
                fontSize: '0.75rem',
            },
        },
        '& .age-verification.error': {
            height: '16px',
            '@media (max-width: 767px)': {
                paddingTop: '0px',
            },
            '@media (max-width: 600px)': {
                padding: '4px 0px 8px 15px',
            },
        },

    },
    cardTitleZipCode: {
        fontSize: '18px',
        lineHeight: '23px',
    },
    topContent: {
        '& h3': {
            margin: '0px',
            fontSize: '1.25rem',
            lineHeight: '1.75rem',
            textAlign: 'left',
        },
    },
    verificationContainer: {
        display: 'flex',
        maxWidth: 'unset !important',
        '@media screen and (max-width: 600px)': {
            display: 'block',
        },
    },
    enterBirthInput: {
        '& >div': {
            '&:after': {
                content: 'inherit',
            },
            '&:before': {
                content: 'inherit',
            },
        },
    },
    enterBirthYearInput: {
        '& >div': {
            '&:after': {
                content: 'inherit',
            },
            '&:before': {
                content: 'inherit',
            },
            '& .Mui-error': {
                display: 'none',
            },
        },
    },
    zipField: {
        '&:after': {
            content: 'inherit',
        },
        '&:before': {
            content: 'inherit',
        },
    },
    birth: {
        width: '65%',
        '@media screen and (max-width: 768px)': {
            width: '100%',
        },
        '@media screen and (max-width: 600px)': {
            width: '100%',
        },
    },
    panelRoot: {
        boxShadow: 'none',
        backgroundColor: 'inherit',
        margin: '14px 0px 0px !important',
        '&:before': {
            display: 'none',
        },
        '&.Mui-expanded': {
            margin: '0px',
            paddingBottom: '10px',
            borderBottom: `2px solid ${theme.palette.cms?.tertiary_hover}`,
        },
    },
    summaryRoot: {
        backgroundColor: 'inherit',
        minHeight: 'auto',
        padding: '0px',
        fontSize: '1.125rem',
        '&.Mui-expanded': {
            margin: '0px',
            minHeight: 'auto',
            marginBottom: '10px',
        },
        '& .MuiExpansionPanelSummary-content': {
            margin: '0px',
        },
    },
    detailsRoot: {
        padding: '0px',
        fontSize: '0.875rem',
        maxHeight: '312px',
        overflow: 'hidden',
        flexDirection: 'column',
        '& ul': {
            marginTop: '0px',
        },
        '& button': {
            color: theme.palette.primary.main || '#2F2F2F',
            fontWeight: 700,
        },
        '& p': {
            fontSize: '1rem',
            lineHeight: '1.5rem',
        },
    },
    icons: {
        display: 'flex',
        alignItems: 'center',
        '& svg': {
            width: '24px',
            height: '24px',
        },
    },
    ageInput: {
        position: 'relative',
        padding: '0px',
    },
    form: {
        margin: '5px 0px 0px 0px',
    },
    icon: {
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
    },
    submitButton: {
        backgroundColor: theme.palette.primary.main || '#2F2F2F',
        color: theme.palette.cms?.white || '#ffffff',
        margin: '0px',
        width: '100%',
        padding: '16px 0px',
        textTransform: 'capitalize',
        fontSize: '18px',
        maxHeight: '55px',
        '&:hover': {
            backgroundColor: theme.palette.primary.main || '#2F2F2F',
        },
    },
    headerContent: {
        fontSize: '18px',
        lineHeight: '23px',
        fontWeight: 700,
    },
    label: {
        fontSize: '0.875rem',
        lineHeight: '1.125rem',
        display: 'flex',
        alignItems: 'center',
    },
    closeBox: {
        display: 'flex',
        padding: '5px',
        justifyContent: 'end',
        cursor: 'pointer',
    },
    ageVerificationSummary: {
        fontWeight: 100,
    },
}));

const ProductVerification = ({
    zipField,
    dayErrorMessage,
    monthErrorMessage,
    yearErrorMessage,
    zipFieldRef,
    getBirthDay,
    getBirthMonth,
    getBirthYear,
    handleAgeVerification,
    validateFields,
    handleZipChange,
    displayZipValidCSSCheck,
    oncloseDrawer,
    selectedItem,
    birthDay,
    birthMonth,
    birthYear,
    hasAddons,
    displayAdditionalCompliance,
    open,
    setOpen,
    handleAddToCart,
    productBrand,
    recipientDayErrorMessage,
    recipientYearErrorMessage,
    recipientBirthDay,
    recipientBirthMonth,
    recipientBirthYear,
    recipientMonthErrorMessage,
}) => {
    const wineContainerRef = useRef(null);
    const dispatch = useDispatch();
    const classes = useStyles();
    const wineValidation = useSelector(getWineData);
    const zipValid =  useSelector(getIsProductFilterZipcodeValid);
    const allFieldsValid = !dayErrorMessage && !monthErrorMessage && !yearErrorMessage;
    const stateValue = useSelector((state) => getUserState(state));
    const allRecipientFieldValid = !recipientDayErrorMessage && !recipientMonthErrorMessage && !recipientYearErrorMessage && recipientBirthDay && recipientBirthMonth && recipientBirthYear;
    const recipientDOB = !!(stateValue === 'HI' || stateValue === 'WI');

    const brand = useSelector(getBrand);
    const [triggerTastingRestrictionsModal, setTriggerTastingRestrictionsModal]  = useState(false);
    const  handleTastingRestrictionsModal = (flag) => {
        setTriggerTastingRestrictionsModal(flag);
    };
    const [contentActive, setContentActive] = useState(false);
    const [zipError, setZipError] = useState(false);
    const [dobError, setDobError] = useState(false);
    const [recipientDobError, setRecipientDobError] = useState(false);
    const [productNotAvailableError, setProductNotAvailableError] = useState(false);
    const handleChangePanel = (panel) => (event, newExpanded) => {
        setContentActive((newExpanded) ? panel : null);
    };
    useEffect(() => {
        if (wineValidation?.wineAvailability?.[0]?.isProductAvailable && productNotAvailableError) {
            setProductNotAvailableError(false);
        }
    }, [wineValidation?.wineAvailability?.[0]?.isProductAvailable]);
    useEffect(() => () => {
        dispatch(resetWineData());
    }, []);
    const handleWineAddToCart = () => {
        let hasError = false;
        const isDobIncomplete = !birthDay || !birthMonth || !birthYear || birthYear?.length < 4;
        const isRecipientDobIncomplete = (!recipientBirthMonth || !recipientBirthDay || !recipientBirthYear || recipientBirthYear?.length < 4) && (stateValue === 'HI' || stateValue === 'WI');
        const recipientAgeError = handleAgeVerification('recipient')?.error ?? true;
        const selfAgeError = handleAgeVerification()?.error ?? true;
        const checkAgeValidation = (stateValue === 'HI' || stateValue === 'WI') ? !recipientAgeError && !selfAgeError : !selfAgeError;
        if (!zipField || zipField?.length < 5) {
            setZipError(true);
            hasError = true;
        }
        if (isDobIncomplete) {
            setDobError(true);
            hasError = true;
        }
        if (isRecipientDobIncomplete) {
            setRecipientDobError(true);
            hasError = true;
        }
        if (wineValidation?.wineAvailability?.length > 0 && !wineValidation?.wineAvailability?.[0]?.isProductAvailable && !isRecipientDobIncomplete && !isDobIncomplete && zipField?.length >= 5 && zipValid) {
            setProductNotAvailableError(true);
            hasError = true;
        }
        if (!hasError && zipValid && wineValidation?.wineAvailability?.[0]?.isProductAvailable && checkAgeValidation) {
            handleAddToCart();
            setOpen(false);
        }
    };
    return (
        <>
            <Dialog
                PaperProps={{
                    className: hasAddons ? classes.addonsVerificationMobile : classes.addonsVerification,
                }}
                open={open}
                maxWidth="xs"
                onClose={() => { setOpen(false); }}
            >
                <DialogTitle className={classes.dialogHeader}>
                    <span className={classes.headerContent}>Age Confirmation for Alcohol Purchases</span>
                    <span role="presentation" onClick={() => { setOpen(false); }} className={classes.icon}>
                        <CloseIcon  />
                    </span>
                </DialogTitle>
                <DialogContent data-testid="ageVerificationForm-modal-content" className={classes.dialogContent} ref={wineContainerRef}>
                    <p className={classes.ageVerificationSummary}>
                        I swear or affirm that: a) I am 21 years of age or older; b) my purchase of wine products is intended for personal consumption and not for resale; and c) the person receiving wine products is 21 years of age or older and will provide proof of age with valid identification and signature upon delivery.
                    </p>
                    <ExpansionPanel classes={{ root: classes.panelRoot }} square expanded={contentActive} onChange={handleChangePanel(index)}>
                        <ExpansionPanelSummary classes={{ root: classes.summaryRoot, content: classes.summaryContent }}>
                            <Typography
                                component="span"
                                variant="h6"
                                className={classes.label}
                            >
                                <div className={classes.container}>
                                    <div className={classes.header}>More info about wine purchases</div>
                                </div>
                                <span
                                    className={classes.icons}
                                    data-testid="infoCloseIcon" // unit test
                                >
                                    {contentActive ? (
                                        <ChevronUp color="#2F363D" width={24} height={24} />
                                    ) : (
                                        <ChevronDown color="#2F363D" width={24} height={24} />
                                    )}
                                </span>
                            </Typography>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails classes={{ root: classes.detailsRoot }}>
                            <GraphqlWineCompliance brand={productBrand ? { 'domain-name': productBrand } : brand} handleTastingRestrictionsModal={handleTastingRestrictionsModal} />
                        </ExpansionPanelDetails>
                    </ExpansionPanel>
                    <AgeVerificationRecipientForm
                        isModal
                        hasAddons={hasAddons}
                        oncloseDrawer={oncloseDrawer}
                        getBirthMonth={getBirthMonth}
                        validateFields={validateFields}
                        birthMonth={birthMonth}
                        monthErrorMessage={monthErrorMessage}
                        getBirthDay={getBirthDay}
                        birthDay={birthDay}
                        dayErrorMessage={dayErrorMessage}
                        getBirthYear={getBirthYear}
                        birthYear={birthYear}
                        yearErrorMessage={yearErrorMessage}
                        handleAgeVerification={handleAgeVerification}
                        handleZipChange={handleZipChange}
                        zipField={zipField}
                        zipFieldRef={zipFieldRef}
                        displayZipValidCSSCheck={displayZipValidCSSCheck}
                        wineContainerRef={wineContainerRef}
                        displayAdditionalCompliance={displayAdditionalCompliance}
                        selectedItem={selectedItem}
                        classes={classes}
                        inlinePDPAddon
                        recipientDayErrorMessage={recipientDayErrorMessage}
                        recipientYearErrorMessage={recipientYearErrorMessage}
                        recipientBirthDay={recipientBirthDay}
                        recipientBirthMonth={recipientBirthMonth}
                        recipientBirthYear={recipientBirthYear}
                        recipientMonthErrorMessage={recipientMonthErrorMessage}
                        stateValue={stateValue}
                        zipError={zipError}
                        dobError={dobError}
                        recipientDobError={recipientDobError}
                        productNotAvailableError={productNotAvailableError}
                        setDobError={setDobError}
                        setZipError={setZipError}
                        setRecipientDobError={setRecipientDobError}
                        setProductNotAvailableError={setProductNotAvailableError}

                    />
                    <div className={classes.buttonContainer}>
                        <Button
                            className={classes.submitButton}
                            onClick={() => {
                                handleWineAddToCart();
                            }}
                            data-testId="submit"
                        >
                            submit
                        </Button>
                    </div>

                </DialogContent>
            </Dialog>
            <Dialog
                PaperProps={{
                    className: classes.addonsVerification,
                }}
                open={triggerTastingRestrictionsModal}
                maxWidth="xs"
                onClose={() => { setTriggerTastingRestrictionsModal(false); }}
            >
                <DialogTitle className={classes.dialogHeader}>
                    <span className={classes.headerContent}>WINE SHIPPING DETAILS</span>
                    <span role="presentation" onClick={() => { setTriggerTastingRestrictionsModal(false); }} className={classes.closeBox}>
                        <CloseIcon />
                    </span>
                </DialogTitle>
                <DialogContent data-testid="tasting-restrictions-modal-content" className={classes.dialogContent}>
                    <div className={classes.wineContainer} data-testid="wine-shipping-details">
                        <GraphqlWineRestrictions productBrand={productBrand} path="/h/view/wineship" />
                    </div>
                </DialogContent>
            </Dialog>
        </>

    );
};

ProductVerification.defaultProps = {
    hasAddons: false,
    displayAdditionalCompliance: false,
    open: false,
    handleAddToCart: () => {},
    productBrand: '',
    oncloseDrawer: () => {},
};

ProductVerification.propTypes = {
    zipField: string.isRequired,
    birthDay: string.isRequired,
    birthMonth: string.isRequired,
    birthYear: string.isRequired,
    dayErrorMessage: string.isRequired,
    monthErrorMessage: string.isRequired,
    yearErrorMessage: string.isRequired,
    zipFieldRef: func.isRequired,
    getBirthDay: func.isRequired,
    getBirthMonth: func.isRequired,
    getBirthYear: func.isRequired,
    handleAgeVerification: func.isRequired,
    validateFields: func.isRequired,
    handleZipChange: func.isRequired,
    displayZipValidCSSCheck: func.isRequired,
    oncloseDrawer: func,
    selectedItem: shape({
        id: string.isRequired,
    }).isRequired,
    open: bool,
    setOpen: func.isRequired,
    hasAddons: bool,
    displayAdditionalCompliance: bool,
    handleAddToCart: func,
    productBrand: string,
    recipientDayErrorMessage: string.isRequired,
    recipientYearErrorMessage: string.isRequired,
    recipientBirthDay: string.isRequired,
    recipientBirthMonth: string.isRequired,
    recipientBirthYear: string.isRequired,
    recipientMonthErrorMessage: string.isRequired,

};

export default ProductVerification;
